import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { resolveRoute } from "@/lib/resolveRoute";
import { useScrollSolidHeader } from "@/lib/useScrollSolidHeader";
import LanguageSwitcher from "./LanguageSwitcher.jsx";
import MainNav from "./MainNav.jsx";
import UniversityAction from "./UniversityAction.jsx";

export default function Header({ lang }) {
  const { t } = useTranslation();
  const isSolid = useScrollSolidHeader();

  return (
    <header className={`tgwe-header ${isSolid ? "is-solid" : ""}`}>
      <a className="skip-link" href="#main-content">
        Skip to content
      </a>
      <div className="tgwe-header__inner">
        <Link className="tgwe-brand" to={resolveRoute(lang, "home")} aria-label={t("site.name")}>
          <img className="tgwe-brand__logo" src="/assets/images/TGW_logo_def.png" alt="" />
        </Link>
        <MainNav lang={lang} />
        <div className="tgwe-header__actions">
          <LanguageSwitcher lang={lang} />
          <UniversityAction iconOnly variant="secondary" />
        </div>
      </div>
    </header>
  );
}
